import { deleteDoc, doc } from "firebase/firestore";
import { docData } from "rxfire/firestore";

import { firestore } from "../firebase";

export const collectionName = "refresh-tokens";

export const store = {
  getByUserId: (userId) => {
    const docRef = doc(firestore, collectionName, userId);

    return docData(docRef, { idField: "id" });
  },

  delete: (userId) => {
    const docRef = doc(firestore, collectionName, userId);

    return deleteDoc(docRef);
  },
};
